import { render, staticRenderFns } from "./salesRuleTeam.vue?vue&type=template&id=50b50ec0&scoped=true"
import script from "./salesRuleTeam.vue?vue&type=script&lang=js"
export * from "./salesRuleTeam.vue?vue&type=script&lang=js"
import style0 from "./salesRuleTeam.vue?vue&type=style&index=0&id=50b50ec0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b50ec0",
  null
  
)

export default component.exports